import { FooterSchema } from './Footer.styles';

export const footerStyles: FooterSchema = {
  footer: {
    pt: '0',
    bg: 'transparent',
    bgSize: 'cover',
    bgPos: 'bottom',
    color: 'white',
  },
  stackGap: '1',
  footerBar: {
    display: 'flex',
    flexDir: ['column', null, 'row'],
    pr: '0',
    mb: '6',
    borderRadius: 'md',
    alignItems: 'center',
    justifyContent: ['center', null, 'unset'],
    sx: {
      '& > img': {
        maxW: '250px',
        ml: '-1',
      },
    },
  },
  footerLink: {
    color: 'beta.400',
    textTransform: 'lowercase',
    cursor: 'pointer',
    display: 'inline-block',
    mt: '0',
    whiteSpace: 'nowrap',
    fontWeight: 'bold',
  },
  footerLinkTel: {
    color: 'beta.400',
    textTransform: 'lowercase',
    cursor: 'pointer',
    display: 'inline-block',
    mt: '0',
    whiteSpace: 'nowrap',
    fontWeight: 'bold',
  },
  customFooterLink: {
    color: 'beta.400',
    textTransform: 'capitalize',
    cursor: 'pointer',
    display: 'inline-block',
    mt: '0',
    whiteSpace: 'nowrap',
    fontWeight: 'bold',
    fontSize: 'base',
  },
  footerLinks: {
    ml: ['unset', null, 'auto'],
    pb: ['4', null, '0'],
    alignItems: 'center',
    justifyContent: ['space-around', null, 'unset'],
    color: 'beta.400',
    fontWeight: 'medium',
    flexDir: ['row', null, 'unset'],
    display: 'inline-flex',
    mt: ['3', null],
  },
  footerLinkService: {
    color: 'beta.400',
    fontSize: 'md',
  },
  footerContentContainer: {
    px: ['2.5', 'unset'],
    gap: ['2', '6'],
    bg: [null, null, 'transparent'],
    justifyContent: 'space-between',
    sx: {
      '&': {
        flexDirection: 'column',
      },
    },
  },
  footerDownloadImage: {
    borderRadius: 'md',
    border: '2px solid white',
  },
  nav: {
    minW: [null, null, '370px'],
    mt: ['0', 'unset'],
    display: ['flex', 'grid'],
    gridTemplateColumns: '1fr 1fr 1fr',
    gridTemplateRows: 'auto',
    columnGap: '28',
    rowGap: '0',
    alignItems: ['center', 'end'],
    gridTemplateAreas: `
      ". ."
    `,
    sx: {
      '> a': {
        color: 'white',
      },
    },
  },
  blurb: {
    flex: 'unset',
    textAlign: ['center', 'left'],
    color: 'white',
    width: 'unset',
    mb: '0',
    ml: [null, '0'],
    mr: [null, null, '4'],
  },
  blurbHeading: {
    ml: 'unset',
    mt: 'unset',
    color: 'white',
  },
  blurbHeadingAge: {
    color: 'white',
    border: '4px',
    mb: '2',
    boxSize: '8',
    fontSize: 'xs',
    lineHeight: 'normal',
  },
  blurbHeadingThink: {
    fontSize: 'xs',
    color: 'white',
    fontWeight: 'bold',
    mb: '4',
  },
  blurbContent: {
    ml: 'unset',
    mr: [null, null, 'auto'],
    color: 'white',
    fontSize: 'sm',
  },
  copyright: {
    color: 'white',
    textAlign: ['center', 'left'],
    mt: ['7'],
    px: ['8', 'unset'],
    py: '0',
    fontWeight: ['semibold', 'medium'],
  },
  copyrightContainer: {
    color: 'beta.200',
  },
  container: {
    bg: 'transparent',
    borderRadius: ['0', '0', '8'],
    mt: '3',
    sx: {
      '&&': {
        px: '0',
      },
    },
  },
  emailUs: {
    fontSize: 'md',
    fontWeight: 'bold',
    color: 'white',
  },
  quickLinks: {
    color: ['beta.400', 'white'],
    textTransform: ['uppercase', 'none'],
    textAlign: ['center', 'left'],
    fontSize: ['xs', 'md'],
  },
  ourPartners: {
    fontSize: ['xs', 'md'],
    color: ['beta.400', 'white'],
    textTransform: ['uppercase', 'none'],
  },
  weAccept: {
    fontSize: ['xs', 'md'],
    color: ['beta.400', 'white'],
    textTransform: ['uppercase', 'none'],
  },
  partnerWrapper: {
    mr: 'unset',
  },
  weAcceptBox: {
    mb: ['0', '2'],
  },
};
